import { render } from "./specialCharacters.vue?vue&type=template&id=a85302a0"
import script from "./specialCharacters.vue?vue&type=script&lang=js"
export * from "./specialCharacters.vue?vue&type=script&lang=js"

import "./specialCharacters.vue?vue&type=style&index=0&id=a85302a0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__